export const PIE_COLORS = ['#2AA6FF', '#FF7324', '#FFC224', '#E94D4D', '#CAE9FF'];

export const CHART_MAIN_COLOR = '#2BA6FF';
